// extracted by mini-css-extract-plugin
export default {"tabs":"Tabs_tabs__eUKbB","tab":"Tabs_tab__K0gJH","active":"Tabs_active__yeC67"};